'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createPlugin = require('./EditorCore/createPlugin');

var _createPlugin2 = _interopRequireDefault(_createPlugin);

var _EditorCore = require('./EditorCore');

var _EditorCore2 = _interopRequireDefault(_EditorCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// export this package's api
/*eslint-disable*/
console.error = function () {
    var error = console.error;
    return function (exception) {
        if ((exception + '').indexOf('Warning: A component is `contentEditable`') != 0) {
            error.apply(console, arguments);
        }
    };
}();

var EditorCorePublic = {
    EditorCore: _EditorCore2["default"],
    GetText: _EditorCore2["default"].GetText,
    GetHTML: _EditorCore2["default"].GetHTML,
    toEditorState: _EditorCore2["default"].ToEditorState,
    createPlugin: _createPlugin2["default"]
};
exports["default"] = EditorCorePublic;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-editor-core/lib/index.js
 ** module id = 237
 ** module chunks = 0
 **/